import { useDispatch } from "react-redux";
import { insuranceActions } from "../model";

export function useStepperState() {
  const dispatch = useDispatch();

  const stepperCompleteDetermineLenderRequirements = () => {
    dispatch(insuranceActions.updateStepperConfig({ idx: 0, config: { active: false, completed: true } }));
    dispatch(insuranceActions.updateStepperConfig({ idx: 1, config: { active: true, completed: false } }));

    dispatch(insuranceActions.updateAccordionConfig({ idx: 1, config: { disabled: false, expanded: true } }));
  };

  const stepperCompleteAgentInformationNeeded = () => {
    dispatch(insuranceActions.updateStepperConfig({ idx: 1, config: { active: false, completed: true } }));
    dispatch(insuranceActions.updateStepperConfig({ idx: 2, config: { active: true, completed: false } }));

    dispatch(insuranceActions.updateAccordionConfig({ idx: 2, config: { disabled: false, expanded: true } }));
  };

  const stepperCompleteVerifyCoverage = () => {
    dispatch(insuranceActions.updateStepperConfig({ idx: 2, config: { active: false, completed: true } }));
    dispatch(insuranceActions.updateStepperConfig({ idx: 3, config: { active: true, completed: true } }));
  };

  const stepperUnCompleteVerifyCoverage = () => {
    dispatch(insuranceActions.updateStepperConfig({ idx: 3, config: { active: false, completed: false } }));
    dispatch(insuranceActions.updateStepperConfig({ idx: 2, config: { active: true, completed: false } }));
  };

  return {
    stepperCompleteDetermineLenderRequirements,
    stepperCompleteAgentInformationNeeded,
    stepperCompleteVerifyCoverage,
    stepperUnCompleteVerifyCoverage,
  };
}
